<app-main>
  <h1>Dashboard</h1>
  <div class="button">
    <button
      mat-mini-fab
      (click)="exportCsv()"
      matTooltip="Exporter le tableau"
      style="margin-right: 16px"
    >
      <mat-icon>cloud_download</mat-icon>
    </button>

    <button mat-raised-button (click)="openInfos()">Légende</button>
  </div>
  <div class="filtre">
    <mat-accordion>
      <mat-expansion-panel style="margin-bottom: 16px">
        <mat-expansion-panel-header>
          <mat-panel-title> Filtres de recherche </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="searchForm">
          <form [formGroup]="form" class="formFiltre">
            <!-- Ligne des form-fields -->
            <div class="form-field-row">
              <mat-form-field>
                <mat-label>Client</mat-label>
                <input
                  type="text"
                  matInput
                  [matAutocomplete]="auto"
                  formControlName="correspondance"
                />
                <mat-autocomplete
                  autoActiveFirstOption
                  #auto="matAutocomplete"
                  [displayWith]="displayClient"
                  (optionSelected)="clientSelected($event)"
                >
                  @for (correspondance of filteredCorrespondance | async; track
                  $index) {
                  <mat-option [value]="correspondance">
                    {{ correspondance.libelleDivalto }}
                  </mat-option>
                  }
                </mat-autocomplete>
              </mat-form-field>

              <mat-form-field>
                <mat-label>Commercial</mat-label>
                <input
                  matInput
                  [(ngModel)]="commercial"
                  formControlName="commercial"
                />
              </mat-form-field>

              <mat-form-field>
                <mat-label>Date fin contrat BIT</mat-label>
                <input
                  matInput
                  [matDatepicker]="picker"
                  formControlName="dateFinContrat"
                />
                <mat-hint>DD/MM/YYYY</mat-hint>
                <mat-datepicker-toggle
                  matIconSuffix
                  [for]="picker"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>

              <mat-form-field style="width: 250px">
                <mat-label>Choisissez une date de syncro</mat-label>
                <mat-select [(value)]="selectedSyncro" formControlName="syncro">
                  @for (syncro of allSyncro; track syncro) {
                  <mat-option [value]="syncro">{{
                    syncro.date | date : "dd/MM/yyyy à HH:mm"
                  }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>

            <!-- Ligne des slide-toggle -->
            <div class="toggle-row">
              <mat-button-toggle-group
                name="errors"
                [value]="selectedErrorType"
              >
                <mat-button-toggle 
                  value="all" 
                  (click)="toggleSelection('all')"
                >
                  Afficher toutes les erreurs
                </mat-button-toggle>
            
                <mat-button-toggle 
                  value="commercial" 
                  (click)="toggleSelection('commercial')"
                >
                  Afficher les erreurs commerciales
                </mat-button-toggle>
            
                <mat-button-toggle 
                  value="technical" 
                  (click)="toggleSelection('technical')"
                >
                  Afficher les erreurs techniques
                </mat-button-toggle>
              </mat-button-toggle-group>
            </div>
            <div>
              <button mat-raised-button type="button" (click)="openErrorLogs()">Voir les erreurs</button>
            </div>
            
          </form>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>

  @if (selectedSyncro?.statut == "E") {
  <div style="text-align: center; margin-top: 256px">
    <span style="font-size: xx-large; text-align: center; color: rgb(31, 202, 255);"
      >Syncro en cours d'exécution...</span
    >
  </div>
  } @else {
  <table
    mat-table
    [dataSource]="dataComparisons"
    class="custom-table"
    matSort
    (matSortChange)="sortChange($event)"
  >
    <!-- Colonne Client -->
    <ng-container matColumnDef="codeDivalto">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        sortActionDescription="Trier par code Divalto"
      >
        Code Divalto
      </th>
      <td mat-cell *matCellDef="let element" class="no-click-cell">
        <div
          class="cell-with-icon"
          style="text-align: left; justify-content: start; padding-left: 5%;"
        >
        <div class="icon-wrapper">
          <mat-icon
            class="icon-item"
            aria-hidden="false"
            [matBadge]="element.commentaires?.length || 0"
            [matBadgeHidden]="(element.commentaires?.length || 0) === 0"
            matBadgeColor="primary"
            matBadgeOverlap="false"
            matBadgeSize="medium"
            matTooltip="Voir les commentaires"
            (click)="$event.stopPropagation(); showCommentaire(element)"
          >
            comment
          </mat-icon>
        
          @if (element.haveIncidentAffranchi) {
          <mat-icon
            class="icon-item"
            matTooltip="Un ou plusieurs incidents sont affranchis pour ce client"
          >
            report_off
          </mat-icon>
          }
        </div>
        
          {{ element.correspondance.codeDivalto }}
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="libelleDivalto">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        sortActionDescription="Trier par code Divalto"
      >
        Nom Client
      </th>
      <td mat-cell *matCellDef="let element">
        <div
          class="cell-with-icon"
          style="text-align: center; justify-content: center"
        >
          {{ element.correspondance.libelleDivalto }}
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="commercial">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        sortActionDescription="Trier par code Divalto"
      >
        Commercial
      </th>
      <td mat-cell *matCellDef="let element">
        <div
          class="cell-with-icon"
          style="text-align: center; justify-content: center"
        >
          {{ element.commercial }}
        </div>
      </td>
    </ng-container>

    <!-- Colonne Entité (labels) -->
    <ng-container matColumnDef="Entite">
      <th mat-header-cell *matHeaderCellDef>Entité</th>
      <td mat-cell *matCellDef="let element">
        <div class="cell-split">
          <ng-container *ngFor="let mod of displayedModules">
            <div class="cell-part" *ngIf="shouldShow(element, mod.key)">
              {{ mod.label }}
            </div>
          </ng-container>
        </div>
      </td>
    </ng-container>

    <!-- Colonnes Divalto / RG / BIT -->
    <ng-container *ngFor="let source of dataSources" [ngSwitch]="source">
      <ng-container [matColumnDef]="source">
        @if (source.replace("Data", "").toUpperCase() == "DIVALTO") {
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Trier par nombre Divalto"
        >
          {{ source.replace("Data", "").toUpperCase() }}
        </th>
        } @else {
        <th mat-header-cell *matHeaderCellDef>
          {{ source.replace("Data", "").toUpperCase() }}
        </th>
        }

        <td mat-cell *matCellDef="let element">
          <div [ngClass]="getCellSplitClass(element, source)">
            <ng-container *ngFor="let mod of displayedModules">
              <div
                class="cell-part"
                *ngIf="shouldShow(element, mod.key)"
                [ngClass]="getColorClass(element, source + '.' + mod.field)"
              >
                {{ getValue(element, source, mod.field) }}
              </div>
            </ng-container>
          </div>
        </td>
      </ng-container>
    </ng-container>

    <!-- Colonne Date fin contrat BIT -->
    <ng-container matColumnDef="dateFinContrat">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        sortActionDescription="Trier par date de fin contrat BIT"
        class="center-header"
      >
        Date fin contrat BIT
      </th>
      <td mat-cell *matCellDef="let element" class="single-cell-part">
        <div
          class="cell-part"
          [ngClass]="getColorClass(element, 'dateFinContrat')"
        >
          @if (element.dateFinContrat) {
          {{ element.dateFinContrat | date : "dd/MM/yyyy" }}
          <!-- } @else { Pas de contrat BIT } -->
        } @else {{{ getTexteContrat(element) }}}
        </div>
      </td>
    </ng-container>

    <tr
      mat-header-row
      *matHeaderRowDef="displayedColumns; sticky: true"
      class="header-row"
    ></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      (click)="onRowClicked(row)"
    ></tr>
  </table>

  <mat-paginator
    [length]="pageInformations.totalElements"
    [pageSize]="pageInformations.size"
    [pageSizeOptions]="[10, 25, 50]"
    [pageIndex]="pageInformations.pageIndex"
    (page)="onPageEvent($event)"
    style="margin-top: 16px"
  ></mat-paginator>
  }
</app-main>

<ngx-spinner
  bdColor="rgba(0,0,0,0.8)"
  size="medium"
  color="#fff"
  type="ball-spin-clockwise"
  [fullScreen]="true"
></ngx-spinner>
